<!-- 设置 -> 销售定价 -->
<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库开始"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库结束"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="捆包号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.bill_lading_no" placeholder="提单号" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectsalePriceSeeList('supplier_id')">
                    <el-option v-for="list in selectMapT.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectsalePriceSeeList('brand_id')">
                    <el-option v-for="list in selectMapT.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectsalePriceSeeList('breed_id')">
                    <el-option v-for="list in selectMapT.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.grade_id" placeholder="等级" multiple @visible-change="getSelectsalePriceSeeList('grade_id')">
                    <el-option v-for="list in selectMapT.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox"  v-if="isShowMore" v-model="params.attribute_id" multiple collapse-tags placeholder="属性" @visible-change="getSelectsalePriceSeeList('attribute_id')">
                    <el-option v-for="list in selectMapT.attribute_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.color_id" multiple collapse-tags placeholder="选色" filterable @visible-change="getSelectsalePriceSeeList('color_id')">
                    <el-option v-for="list in selectMapT.color_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.place_origin" placeholder="产地" size="mini"></el-input>
                <!-- <el-select class="search_select search_inputBox" v-model="params.status" placeholder="状态">
                    <el-option v-for="list in selectMessage.status" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.status" placeholder="销售状态" @visible-change="getSelectsalePriceSeeList('status')">
                    <el-option v-for="list in selectMapT.status" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.bale_status" placeholder="资源状态" @visible-change="getSelectsalePriceSeeList('bale_status')">
                    <el-option v-for="list in selectMapT.bale_status" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.sales_thickness" multiple collapse-tags placeholder="厚度" filterable @visible-change="getSelectsalePriceSeeList('sales_thickness')">
                    <el-option v-for="list in selectMapT.sales_thickness" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.sales_length" multiple collapse-tags placeholder="长度" filterable @visible-change="getSelectsalePriceSeeList('sales_length')">
                    <el-option v-for="list in selectMapT.sales_length" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <!-- <el-input class="search_input search_inputBox" v-model="params.thickness" placeholder="厚度" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.length" placeholder="长度" size="mini"></el-input> -->
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.warehouse_id" placeholder="仓库" multiple @visible-change="getSelectsalePriceSeeList('warehouse_id')">
                    <el-option v-for="list in selectMapT.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.storage_age" placeholder="库龄" size="mini"></el-input>
                <!-- <div class="search_time search_inputBox">
                    <el-date-picker v-model="inbound_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库时间"></el-date-picker>
                </div> -->
                <!-- <el-select class="search_select search_inputBox" v-model="params.port_id" multiple collapse-tags placeholder="目的港">
                    <el-option v-for="list in portList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-input v-model="params.start_price" type="text" placeholder="挂牌价" size="mini"></el-input>
                    ~
                    <el-input v-model="params.end_price" type="text" placeholder="挂牌价" size="mini"></el-input>
                </div>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.original_bale" placeholder="供单号" size="mini"></el-input>
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-input v-model="params.storage_age_start" type="text" placeholder="库龄开始" size="mini"></el-input>
                    ~
                    <el-input v-model="params.storage_age_end" type="text" placeholder="库龄结束" size="mini"></el-input>
                </div>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked"  v-if="module.indexOf(',setting-advanced-pricing-edit,')!=-1" @click="tiao(1)">定价</el-button>
                <el-button class="funcPublicBtn"  v-if="module.indexOf(',setting-advanced-pricing-edit,')!=-1" @click="tiao(2)">调价</el-button>
                <el-button class="funcPublicBtn"  v-if="module.indexOf(',setting-advanced-pricing-edit,')!=-1" @click="notice">公告编辑</el-button>
                <div style="float: left;width: 800px;border: solid 1px;border-radius: 3px;" v-if="this.a.sales_strategy||this.a.boss_message">
                    <div style="float: left;font-size: 12px;" v-if="this.a.sales_strategy">
                        <span style="float: right;" v-if="this.a.sales_strategy">销售策略：{{this.a.sales_strategy }}</span>
                    </div>
                    <br v-if="this.a.sales_strategy"/>
                    <div style="font-size: 12px;float: left;" v-if="this.a.boss_message">
                        <span v-if="this.a.boss_message">BOSS留言：{{this.a.boss_message}}</span>
                    </div>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="system.price.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getTableEdit="getTableEdit" @getRow="getRow"></tabletem>
            </div>
            <div class="totalCal no_print">
            <div class="totalName">合计：</div>
            <div class="totalNumber">{{totalObj.numbers}}件</div>
            <div class="totalNumber">{{totalObj.cube_total}}m³</div>
            <div class="totalNumber">选中件数: {{selectRow.length}}</div>
            <div class="totalNumber">选中立方: {{selectCube}}m³</div>
        </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 修改 dialog START -->
        <el-dialog width="400px" v-dialog-drag :title="setType==1?'销售定价':'销售调价'" :visible.sync="addDialogVisible" class="eldialog ebrldialogSalePrice" :modal="false" custom-class="full_dialog">
            <!-- <div class="setBox">
                <div :class="['setBoxBtn',setType==1?'setBoxBtnC':'']" @click="setType=1">定价</div>
                <div :class="['setBoxBtn',setType==2?'setBoxBtnC':'']" @click="setType=2">调价</div>
            </div> -->
            <div v-if="setType==1">
                <el-form :model="set_params" ref="add_form" class="dialogFormB clearfix">
                    <div class="eldialogSetPriceBoxa clearfix b" v-if="enable_min_price != 0">
                        <el-form-item label="　　　　　最低价：">
                            <el-input v-model="set_params.min_price" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogSetPriceBoxa clearfix">
                        <el-form-item label="　　　　　挂牌价：">
                            <el-input v-model="set_params.sales_price" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogSetPriceBoxa">
                        <el-form-item label="　　　　资源状态：">
                            <el-select v-model="set_params.status" style="width: 40%;">
                                <el-option  v-for="(list,index) in selectMessage.status" :key="index" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="setChangePrice">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                </div>
            </div>
            <div v-if="setType==2">
                <el-form :model="transform_params" class="dialogFormB clearfix">
                    <div class="eldialogTransformPriceBoxa clearfix">
                        <el-form-item label="　　　最低价：" v-if="enable_min_price != 0">
                            <div class="eldialogTransformPrice">
                                <span class="priceSign">+</span>
                                <el-input v-model="transform_params.min_up" @input="transformInput($event,'min_up')" placeholder="上涨"></el-input>
                            </div>
                            <div class="eldialogTransformPrice">
                                <span class="priceSign">-</span>
                                <el-input v-model="transform_params.min_down" @input="transformInput($event,'min_down')" placeholder="下调"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="　　　挂牌价：">
                            <div class="eldialogTransformPrice">
                                <span class="priceSign">+</span>
                                <el-input v-model="transform_params.set_up" @input="transformInput($event,'set_up')" placeholder="上涨"></el-input>
                            </div>
                            <div class="eldialogTransformPrice">
                                <span class="priceSign">-</span>
                                <el-input v-model="transform_params.set_down" @input="transformInput($event,'set_down')" placeholder="下调"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="transformChangePrice">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                </div>
            </div>
            <!-- <div>
                <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                    <div class="eldialogSaleBox clearfix">
                        <el-form-item label="最低价：">
                            <el-input v-model="add_params.min_price" placeholder=""></el-input>
                        </el-form-item>
                        <el-select v-model="add_params.min_price_ext">
                            <el-option v-for="(list,index) in selectMessage.min_price" :key="index" :value="list.name" :label="list.label"></el-option>
                        </el-select>
                        <el-checkbox v-model="min_price_action">增减</el-checkbox>
                    </div>
                    <div class="eldialogSaleBox clearfix">
                        <el-form-item label="挂牌价：">
                            <el-input v-model="add_params.sales_price" placeholder=""></el-input>
                        </el-form-item>
                        <el-select v-model="add_params.sales_price_ext">
                            <el-option v-for="(list,index) in selectMessage.sales_price" :key="index" :value="list.name" :label="list.label"></el-option>
                        </el-select>
                        <el-checkbox v-model="sales_price_action">增减</el-checkbox>
                    </div>
                    <div class="eldialogSaleBox">
                        <el-form-item label="状态：">
                            <el-select v-model="add_params.status">
                                <el-option v-for="(list,index) in selectMessage.status" :key="index" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="changePrice">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                </div>
            </div> -->
        </el-dialog>
        <!-- 修改 dialog END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="system.price.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <el-dialog v-dialog-drag :visible.sync="editNotice" width="360px" title="实时报价单--公告" class="eldialog eldialogSalePrice" :modal="false" custom-class="full_dialog" :before-close="closeNotice">
            <el-form  class="dialogFormB clearfix">
                    <div class="eldialogSetPriceBox clearfix" style="padding-top:30px">
                        <el-form-item  label="销售策略:">
                            <el-input class="a" type="textarea" v-model="sales_strategy" placeholder="输入内容"></el-input>
                        </el-form-item>
                    </div>
                    <div class="eldialogSetPriceBox clearfix" style="padding-top:30px">
                        <el-form-item label="BOSS留言:">
                            <el-input class="a"  type="textarea" v-model="boss_message" placeholder="输入内容"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix" style="padding-top:30px">
                    <el-button  class="publicBtn dialogBtn" @click="setChangeNotice">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="closeNotice">取消</el-button>
                </div>
        </el-dialog>
    </div>
</template>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                addDialogVisible:false,
                editNotice:false,
                a:{
                    sales_strategy:'',
                    boss_message:'',
                },
                transform_params:{
                    ids:[],
                    min_up:"",
                    min_down:"",
                    set_up:"",
                    set_down:""
                },
                set_params:{
                    ids:[],
                    min_price:"",
                    sales_price:"",
                    status:""
                },
                setType:1,
                add_params : {
                    id:[],
                    min_price:"",
                    min_price_ext:"",
                    min_price_action:0,
                    sales_price:"",
                    sales_price_ext:"",
                    sales_price_action:0,
                    status:""
                },
                enable_min_price:1,
                min_price_action:false,
                sales_price_action:false,
                isShowMore:false,
                filterDialogVisible:false,
                sales_strategy:"",
                boss_message:"",
                filter:"",
                fields:"",
                params:{
                    container_no:"",
                    supplier_id:[],
                    brand_id:[],
                    breed_id:[],
                    grade_id:[],
                    color_id:[],
                    place_origin:"",
                    sales_length:"",
                    sales_thickness:"",
                    contract_no:"",
                    bill_lading_no:"",
                    bale_no:"",
                    status:"",
                    warehouse_id:"",
                    storage_age:"",
                    original_bale:"",
                    start_price:"",
                    end_price:"",
                    start_time:"",
                    end_time:"",
                    bale_status:"",
                    storage_age_start:"",
                    storage_age_end:"",
                    page:1,
                    per_page:50
                },
                start_time:"",
                end_time:"",
                last_page: 1,
                current_page: 1,
                total: 0,
                list : [],
                selectMap:{
                    supplier:[],
                    breed:[],
                    brand:[],
                    creater:[],
                    grade:[],
                    port:[],
                    purchaseCost:[],
                    currency:[],
                    warehouse:[]
                },
                selectMapT:{
                    sales_length:[],
                    sales_thickness:[],
                    status:[],
                    bale_status:[],
                    brand_id:[],
                    breed_id:[],
                    supplier_id:[],
                    grade_id:[],
                    color_id:[],
                    warehouse_id:[],
                    attribute_id:[]
                },
                tableCol:[
                    {colName:"资源状态",colKey:"stock_status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供单号",colKey:"original_bale",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供单号",colKey:"original_bale",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"厚度",colKey:"sales_thickness",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"长度",colKey:"sales_length",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"片数",colKey:"pieces",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"成本价",colKey:"cost",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"最低价",colKey:"min_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"选色",colKey:"color",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"产地",colKey:"place_origin",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售状态",colKey:"status_text",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库时间",colKey:"inbound_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"更新时间",colKey:"update_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"库龄",colKey:"storage_age",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"币种",colKey:"foreign_currency_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外币单价",colKey:"foreign_currency_price",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"属性",colKey:"attribute",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                selectRow:[],
                selectMessage:[],
                changeIds:[],
                totalObj:{},
                selectCube:0
            }
        },
        created(){
            this.postFunc("/erp/price.select",{},res=>{
                this.selectMessage.status=res.data.data;
                this.selectMessage.status.push({id:999,name:"全部状态"})
                // this.add_params.sales_price_ext=res.data.data.sales_price[0].name;
                // this.add_params.min_price_ext=res.data.data.min_price[0].name;
                // this.add_params.status=res.data.data.status[0].id;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.gao();
            this.getList();
        },
        methods:{
            tiao(type){
                this.addDialogVisible = !this.addDialogVisible;
                this.setType = type;
                let arr = new Array();
                this.selectRow.forEach(item=>{
                    arr.push(item.id)
                })
                this.changeIds=arr;
            },
            gao(){
                this.postFunc("/erp/price.list.messages","",res=>{
                    let resD = res.data.data
                    this.a.sales_strategy = resD.sales_strategy
                    this.a.boss_message = resD.boss_message
                })
            },
            //公告
            notice(){
                this.editNotice = true
            },
            //公告输入确认
            setChangeNotice(){
                this.postFunc("/erp/sales.price.plate.messages",{sales_strategy:this.sales_strategy,boss_message:this.boss_message},()=>{
                    this.closeNotice()
                })
            },
            //关闭
            closeNotice(){
                this.sales_strategy = '';
                this.boss_message = '';
                this.gao();
                this.editNotice =false;
            },
            getSelectsalePriceSeeList(target){
                this.$getSelectsalePriceSeeList(target,this.params).then(res=>{
                    this.selectMapT[res.data.data.target]=res.data.data.result;
                })
            },
            transformInput(e,type){
                if(type=="min_up"){
                    this.transform_params.min_down = "";
                }else if(type=="min_down"){
                    this.transform_params.min_up = "";
                }else if(type=="set_up"){
                    this.transform_params.set_down = "";
                }else if(type=="set_down"){
                    this.transform_params.set_up = "";
                }
            },
            setChangePrice(){
                this.$confirm('是否确认定价?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.set_params.ids = this.changeIds;
                    this.postFunc("/erp/price.create.price",this.set_params,()=>{
                        this.tip("修改成功","success")
                        this.addDialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            transformChangePrice(){
                this.$confirm('是否确认修改?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let obj = new Object();
                    obj.ids = this.changeIds;
                    // this.transform_params.ids=this.changeIds;
                    if(this.transform_params.min_down == ""){
                        obj.min_price = this.transform_params.min_up
                    }else if(this.transform_params.min_up == ""){
                        obj.min_price = -this.transform_params.min_down
                    } 
                    if(this.transform_params.set_down == ""){
                        obj.sales_price = this.transform_params.set_up
                    }else if(this.transform_params.set_up == ""){
                        obj.sales_price = -this.transform_params.set_down
                    }
                    this.postFunc("/erp/price.update.price",obj,()=>{
                        this.tip("修改成功","success")
                        this.addDialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getSelectsalePricingList(target){
                this.$getSelectsalePricingList(target,this.params).then(res=>{
                    this.selectMapT[res.data.data.target]=res.data.data.result;
                })
            },
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            batchSelect(){
                if(this.selectRow.length<=0){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    this.addDialogVisible=true;
                    let arr = new Array();
                    this.selectRow.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.changeIds=arr;
                }
            },
            changePrice(){
                this.$confirm('是否确认修改?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.min_price_action?this.add_params.min_price_action=1:this.add_params.min_price_action=0;
                    this.sales_price_action?this.add_params.sales_price_action=1:this.add_params.sales_price_action=0;
                    this.add_params.id=this.changeIds;
                    this.postFunc("/erp/system.price.update",this.add_params,()=>{
                        this.tip("修改成功","success")
                        this.addDialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getList(flag){
                this.tableColCopy = this.$deepClone(this.tableCol);
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.params.start_time=this.formatTimeZero(this.start_time)
                this.params.end_time=this.formatTimeZero(this.end_time)
                this.$postColumnList("/erp/price.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data;
                    this.totalObj = res.data.data.totals;
                    this.list.forEach((item,index)=>{
                        // item.isEdit=true;
                        if(item.inbound_time!=0){
                            this.list[index].inbound_time = this.formatTime(item.inbound_time+"000")
                        }else{
                            this.list[index].inbound_time = "";
                        }
                        if(item.update_time){
                            this.list[index].update_time = this.formatTime(item.update_time+"000")
                        }else{
                            this.list[index].update_time = "";
                        }
                    })
                    this.filter = res.data.data.column;
                    this.enable_min_price = res.data.data.enable_min_price;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        // if(item.colKey=="status_text"){
                        //     if(this.fields.indexOf(",status,")!=-1){
                        //         item.isShow=true;
                        //     }
                        // }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getTableEdit(obj){
                this.addDialogVisible=true;
                let arr = new Array();
                arr.push(obj)
                this.changeIds=arr;
            },
            getRow(row){
                this.selectRow=row;
                let number = 0;
                this.selectRow.forEach(item=>{
                    number += Number(item.sales_cube)
                })
                this.selectCube = this.keepLimit(number)
            },
            reset(){
                this.start_time="";
                this.end_time="";
                this.params=this.resetSearch(this.params)
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "addDialogVisible":function(val){
                if(!val){
                    // this.add_params=this.resetJson(this.add_params)
                    // this.add_params.course_title="进销货款";
                    // this.add_params.bill_type=0;
                    // this.changeIds=[];
                    // this.add_params.sales_price_ext=this.selectMessage.sales_price[0].name;
                    // this.add_params.min_price_ext=this.selectMessage.min_price[0].name;
                    // this.add_params.status=this.selectMessage.status[0].id;
                    this.transform_params = {ids:[],min_up:"",min_down:"",set_up:"",set_down:""}
                    this.set_params = {ids:[],min_price:"",sales_price:"",status:""}
                    this.setType = 1;
                }
            }
        }
    }
</script>
<style scoped>
    .setBox{text-align: center;padding-bottom:20px;}
    .setBoxBtn{display: inline-block; padding: 0px 0px;width: 90px;color: #000;font-size: 13px;border-radius: 3px;line-height: 31px;cursor: pointer;border:1px solid #666;margin-right: 15px;font-weight: 600;}
    .setBoxBtnC{background-color: #b21111!important;color: #fff!important;border-color: #b21111;}
    .a >>> .el-textarea__inner{
        padding: 0;
        height: 60px;
    }
    .b >>> .eldialogSetPriceBox .el-form-item .el-form-item__content {
    width: 250px;
    }
  .eldialogSetPriceBoxa .el-form-item .el-form-item__content {
    width: 225px  !important;
  }
    .eldialogSetPriceBoxa .el-input {
        position: relative;
        font-size: 14px;
        display: inline-block;
        width: 40%;
        float: left;
    }
    .eldialogSetPriceBoxa .el-form-item__content {
    line-height: 40px;
    position: relative;
    font-size: 14px;
    float: left;
    }
    .eldialogSetPriceBoxa .el-select {
    display: inline-block;
    position: relative;
    float: left;
    }
    .eldialogTransformPriceBoxa .el-form-item .el-form-item__content {
    position: relative;
    width: 380px  !important;
    }
    .eldialogTransformPriceBoxa .eldialogTransformPrice {
        float: left;
        position: relative;
        width: 30%;
        padding-left: 15px;
        margin-right: 0%;
    }
    .eldialogTransformPriceBoxa .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 68%;
}
</style>
